import React from 'react';

import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { styled } from '@mui/material/styles';

import { ContactButton } from '../../../components/UI/Buttons';

const GradientBackground = styled(Box)(({ theme }) => ({
  backgroundImage: 'linear-gradient(to bottom, #15183A, #638DB8)',
  padding: theme.spacing(8, 0),
  borderRadius: '0',
  borderBottomLeftRadius: '16px',
  borderBottomRightRadius: '16px',
  width: '100%',
}));

const ContactUs: React.FC = () => {
  return (
    <Box width="100%" sx={{ my: 8 }}>
      <GradientBackground>
        <Box display="flex" flexDirection="column" alignItems="center" justifyContent="center" px={4} py={6}>
          <Typography
            variant="h3"
            component="h2"
            align="center"
            gutterBottom
            sx={{
              color: 'white',
              fontWeight: 600,
              mb: 2,
            }}
          >
            Empieza a usar Zeller
          </Typography>

          <Typography
            variant="h6"
            align="center"
            sx={{
              color: 'white',
              mb: 4,
            }}
          >
            Solicita una demo y descubre cómo Zeller puede ayudarte a mejorar tus ventas.
          </Typography>

          <ContactButton
            variant="contained"
            size="large"
            onClick={() => window.open('https://zcal.co/i/O1PPkO_D', '_blank', 'noopener,noreferrer')}
          >
            Habla con nosotros
          </ContactButton>
        </Box>
      </GradientBackground>
    </Box>
  );
};

export default ContactUs;
